import { FC } from 'react'
import { ProductPageLayout } from '~/components/ProductPageLayout/ProductPageLayout'
import { ProductPage } from '~/components/ProductPage/WardrobeProductPage'
import { WardrobeProductConfigurator } from '~/components/ProductPage/productTypes/wardrobe'
import { OpeningType } from '~/components/ThreeDModel/furnitureConfig'

export const preview = {
  name: 'products.wardrobe.2.name',
  link: '/product/wardrobe/2',
  // src: '/wardrobe/White/maner/Base 20/H2100/right/500-1.png',
  src: '/cdn/ready-products/wardrobe/500-1_2.png',
  dimensions: '50x210x50',
  color: 'White',
  price: 3220,
}

const Product: FC = () => {
  return (
    <ProductPageLayout>
      <ProductPage
        components={WardrobeProductConfigurator}
        name={preview.name}
        values={{
          imageCarousel: ['/cdn/ready-products/wardrobe/500-1_2.png'],
          colors: preview.color,
          dimensions: {
            width: 50,
            height: 210,
            depth: 50,
            plintHeight: 2,
          },
          furniture: {
            openingType: OpeningType.RoundHandle,
            guides: 'homepage.configurator.fittings.guides.options.2',
          },
          sections: {
            number: 1,
            mirror: 'nu',
            arrangement: [
              {
                src: '/cdn/wardrobe/filling/White/2100/1.png',
                width: 50,
                height: 210,
              },
            ],
            opening: [
              {
                src: '/cdn/wardrobe/opening-right.png',
                width: 50,
                height: 224,
              },
            ],
          },
          price: preview.price,
        }}
      />
    </ProductPageLayout>
  )
}

export default Product
